























import { Vue, Component, Prop } from 'vue-property-decorator'
import { ElementMixin, HandleDirective } from 'vue-slicksort';
import icon from 'components/presenter/item/ItemIcon'
import { Item } from 'src/graphql/types'

@Component({
  mixins: [ ElementMixin ],
  directives: {
    handle: HandleDirective
  }
})
export default class ItemCourseContentSortableListItem extends Vue {
  icon = icon

  @Prop()
  readonly item!: Item

  @Prop()
  readonly reorder!: boolean
}
